import { render, staticRenderFns } from "./NbgIframe.vue?vue&type=template&id=0415bb6f&scoped=true"
import script from "./NbgIframe.vue?vue&type=script&lang=js"
export * from "./NbgIframe.vue?vue&type=script&lang=js"
import style0 from "./NbgIframe.vue?vue&type=style&index=0&id=0415bb6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0415bb6f",
  null
  
)

export default component.exports